import React from 'react';
import Services from '../Home/Services';
import Footer from '../Layout/Header/Footer';
import Header from '../Layout/Header/Header';
import Testimonial from '../Testimonial/Testimonial';

export default function Contact() {
    return (
        <div>
            <Header />
            content
            <Services />
            <Testimonial />
            <Footer />
        </div>
    );
}
